import { useEffect, useLayoutEffect } from "react";

const isBrowser = typeof window !== "undefined";

// This hook will run on layout effect on the browser and effect on the server
const useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
